import React, { useState, useRef } from 'react';
import { Car, Camera, ArrowRight, ArrowLeft, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProblemStepsScreen = () => {
  const [details, setDetails] = useState({
    carModel: '',
    tireSize: '',
  });
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const handleClose = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmClose = () => {
    navigate('/');
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleNext = () => {
    navigate('/problem-type');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Progress Bar */}
      <div className="h-1 bg-blue-600 w-1/3" />

      {/* Header with Back and Close buttons */}
      <div className="p-4 flex justify-between items-center">
        <button onClick={() => navigate(-1)} className="p-2">
          <ArrowLeft className="w-6 h-6 text-gray-600" />
        </button>
        <button onClick={handleClose} className="p-2">
          <X className="w-6 h-6 text-gray-600" />
        </button>
      </div>

      {/* Main Content - Same as before */}
      <div className="px-4 pb-24">
        {/* Rest of your existing content */}
        <div className="max-w-md mx-auto">
          <div className="mb-8">
            <Car className="w-16 h-16 text-blue-600 mb-4" />
            <h1 className="text-2xl font-bold text-gray-800">
              Ce mașină ai?
            </h1>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-gray-700 text-lg mb-2">
                Model mașină
              </label>
              <input
                type="text"
                placeholder="ex: Volkswagen Golf"
                className="w-full p-4 bg-gray-50 rounded-xl text-gray-800"
                value={details.carModel}
                onChange={(e) => setDetails({...details, carModel: e.target.value})}
              />
            </div>

            <div>
              <label className="block text-gray-700 text-lg mb-2">
                Dimensiune anvelope
              </label>
              <input
                type="text"
                placeholder="ex: 195/65 R15"
                className="w-full p-4 bg-gray-50 rounded-xl text-gray-800"
                value={details.tireSize}
                onChange={(e) => setDetails({...details, tireSize: e.target.value})}
              />
            </div>

            <div>
              <label className="block text-gray-700 text-lg mb-2">
                Adaugă poză (opțional)
              </label>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                ref={fileInputRef}
                onChange={handleImageUpload}
              />
              <button
                onClick={() => fileInputRef.current.click()}
                className="w-full p-4 border-2 border-dashed border-gray-300 rounded-xl flex items-center justify-center gap-2 hover:bg-gray-50"
              >
                <Camera className="w-6 h-6 text-gray-600" />
                <span className="text-gray-600">Încarcă o poză</span>
              </button>
              {imagePreview && (
                <div className="mt-4 relative">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-full h-48 object-cover rounded-xl"
                  />
                  <button
                    onClick={() => setImagePreview(null)}
                    className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full"
                  >
                    ×
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Continue Button - Fixed at bottom */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t">
        <div className="max-w-md mx-auto">
          <button
            onClick={handleNext}
            className="w-full bg-blue-600 text-white p-4 rounded-xl font-medium hover:bg-blue-700 flex items-center justify-center"
          >
            Continuă
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Ești sigur că vrei să renunți?
            </h3>
            <p className="text-gray-600 mb-6">
              Dacă închizi acum, vei pierde toate informațiile introduse.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => setShowConfirmDialog(false)}
                className="flex-1 py-3 px-4 rounded-xl bg-gray-100 text-gray-700 font-medium"
              >
                Nu, rămân
              </button>
              <button
                onClick={handleConfirmClose}
                className="flex-1 py-3 px-4 rounded-xl bg-red-600 text-white font-medium"
              >
                Da, renunț
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProblemStepsScreen;